module.exports = __webpack_public_path__ + "img/down-arrow.b4c8efa5.svg";